import { useLocation, useParams, Link } from "react-router-dom";
import { CheckCircle2, ExternalLink } from "lucide-react";
import { contractResultStatus, formatEuro } from "@/lib/contractApi";
import { contractDisplayPeriod, formatContractPeriod } from "@/lib/contractUser";
import { PublicShell } from "@/pages/PublicContract";

export default function PublicContractResult() {
  const { token } = useParams();
  const location = useLocation();
  const stored = sessionStorage.getItem(`contract-result:${token}`);
  const result = location.state || (stored ? JSON.parse(stored) : null);
  if (!result) {
    return <PublicShell><div className="mx-auto max-w-xl rounded-2xl bg-white p-8 text-center shadow-sm"><h1 className="text-2xl font-semibold">Keine Abschlussdaten verfügbar</h1><p className="mt-3 text-slate-600">Bitte öffne den Vertrag erneut über deinen persönlichen Verwaltungslink.</p></div></PublicShell>;
  }
  const displayPeriod = contractDisplayPeriod(result);
  return (
    <PublicShell>
      <main className="mx-auto max-w-2xl rounded-2xl border border-emerald-200 bg-white p-6 shadow-sm sm:p-10">
        <CheckCircle2 className="h-12 w-12 text-emerald-600" />
        <h1 className="mt-5 text-3xl font-semibold text-slate-950">Vertrag erfolgreich abgeschlossen</h1>
        <p className="mt-3 leading-7 text-slate-600">Dein Nutzungsvertrag wurde sicher gespeichert. Deine Vertragsdaten und die Vertragskopie stehen dir jederzeit im Vertragsportal zur Verfügung.</p>
        <dl className="mt-7 grid gap-4 rounded-xl bg-slate-50 p-5 sm:grid-cols-2">
          <Result label="Vertragsnummer" value={result.contract_number} />
          <Result label="Status" value={contractResultStatus(result)} />
          <Result label="Nutzungszeitraum" value={displayPeriod ? formatContractPeriod(displayPeriod.start, displayPeriod.end) : "–"} />
          <Result label="Gesamtbetrag" value={formatEuro(result.terms.price_cents)} />
        </dl>
        <Link to={`/vertrag-verwalten/${result.management_token}`} className="mt-7 inline-flex items-center gap-2 rounded-xl bg-slate-950 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800">Vertrag verwalten <ExternalLink className="h-4 w-4" /></Link>
        <p className="mt-5 text-sm leading-6 text-slate-500">Du hast ein 14-tägiges Widerrufsrecht. Die Widerrufsfunktion ist während dieser Frist im Verwaltungsbereich sichtbar.</p>
      </main>
    </PublicShell>
  );
}

const Result = ({ label, value }) => <div><dt className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</dt><dd className="mt-1 text-sm font-medium text-slate-950">{value}</dd></div>;
